import { FilesIcon, UploadIcon } from 'lucide-react';

import { Button } from '@@/ui/primitives';
import { LogType } from '../types/visualizer';

export const EmptyState = (props: { message?: string; onSelection: (type: LogType) => void }) => {
  return (
    <div className='flex flex-1 items-center justify-center h-full'>
      <div className='max-w-md text-center space-y-6 p-8'>
        <div className='space-y-3'>
          <div className='mx-auto w-16 h-16 bg-neutral-200 rounded-full flex items-center justify-center'>
            <FilesIcon className='w-8 h-8 text-neutral-400' />
          </div>
          <h2 className='text-xl font-semibold text-neutral-900'>No Data Available</h2>
          <p className='text-neutral-600 text-sm'>{props.message || 'No contact selected or log data available.'}</p>
          <div className='text-sm text-neutral-500 mt-4'>
            <Button variant='default' size='sm' onClick={() => props.onSelection(LogType.INTERACTION_LOG)}>
              <UploadIcon className='w-4 h-4' />
              Select Interaction Log
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
